import React, { useState, useEffect, useContext } from "react";
import TextField from "@material-ui/core/TextField";
import ConfirmationDialog from "./ConfirmationDialog/ConfirmationDialog";
import moment from 'moment';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import AuthContext from "../../../../context/auth-context"
import {setAllowChanges, replaceAll} from "../../utils/utils"

const theme = createMuiTheme({
    overrides: { 
        MuiInputBase: { 
            root: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                lineHeight: "19px",
            }
        }
    },
    palette: {
        primary: {
            main: "#0b1f82"
        },
    }
});

function Observation(props) {
    let roles = useContext(AuthContext).user_data.roles
    let company_key = useContext(AuthContext).user_data.company_key
    let business_group_key = useContext(AuthContext).user_data.business_group_key
    let allowChanges = setAllowChanges(props.transaction.analysis_status, roles, "update_pix_transactions")

    const [openDialog, setOpenDialog] = useState(false)
    const [isApproved, setIsApproved] = useState(null)
    const [observationBox, setObservationBox] = useState(null)
    const [disableChange, setDisableChange] = useState(false)
    const [difference, setDifference] = useState(null)
    const [reason, setReason] = useState('select')

    // Define the specific company_key for which the dropdown should be active
    const DROPDOWN_COMPANY_KEYS = [
        "c9dbc67e-c404-4c42-a684-807bc96043eb", 
        "b26ffc38-6ac6-4883-bf57-49f83cff3ae4", 
        "fe46e6d6-ae66-404e-bc97-f863f151f73a", 
        "123-123-123"
    ]

    // Define the specific business_group_key for which the dropdown should be active
    const DROPDOWN_BUSINESS_GROUP_KEYS = [
        "2ac3b8b5-20dc-4013-81a8-ab61e29bb252",
        "4add615d-bcea-4031-98b7-e79db07a01cd",
        "456-456-456"
    ]

    // Calculate initial difference between NOW and limit_date
    useEffect(() => {
        if (allowChanges && props.transaction?.manual_analysis_limit_date) {
            const timer = setTimeout(() => {
                const now = moment()
                const limit = moment(props.transaction?.manual_analysis_limit_date)
                const diff = limit.diff(now, 'seconds')
                setDifference(diff)
            }, 500)
            return () => {
                clearTimeout(timer)
            }
        }
    }, [allowChanges, props])

    useEffect(() => {
        if (difference === null) {
            return      
        }
        else if (difference < 0) {
            setDisableChange(true)
        }
        else {
            const timer = setTimeout(() => {
                setDisableChange(true)
            }, difference * 1000)
            return () => {
                clearTimeout(timer)
            }
        }
    }, [difference])

    const handleApprovedOpenClick = () => {
        setIsApproved(true)
        setOpenDialog(true)
    };

    const handleReprovedOpenClick = () => {
        setIsApproved(false)
        setOpenDialog(true)
    };

    const handleDialogClose = () => {
        setOpenDialog(false)
        setTimeout(function () { setIsApproved(null) }, 300)
    };

    const handleObservationBoxChange = (event) => {
        if (event.target.value.length === 0) {
            setObservationBox(null)
        }
        else {
            setObservationBox(event.target.value)
        }
    };

    const updateReason = (newReason) => {
        if (newReason === 'application_fraud') {
            setObservationBox('application_fraud: ')
        } else if (newReason === 'mule_account') {
            setObservationBox('mule_account: ')
        } else if (newReason === 'scammer_account') {
            setObservationBox('scammer_account: ')
        } else if (newReason === 'other') {
            setObservationBox('other: ')
        } else {
            setObservationBox('')
        }
        setReason(newReason)
    }

    let observation = null
    let analyst = null
    if (!allowChanges) {
        let last_event = props.transaction.analysis_events == null || props.transaction.analysis_events.length === 0 ? null :
            props.transaction.analysis_events[props.transaction.analysis_events.length - 1]
        if (last_event) {
            observation = last_event.observation
            let string = last_event.analyst_name == null ? null : "Análise feita por %name, %email no dia %day às %time.\n"
            let mapObj = {
                "%name": last_event.analyst_name,
                "%email": last_event.analyst_email,
                "%day": moment(last_event.event_date).format("DD/MM/YYYY"),
                "%time": moment(last_event.event_date).format("HH:mm"),
            }
            analyst = string == null ? null : replaceAll(string, mapObj)
        }
    }

    return (
        <div className="analysisCard">
            <div style={{ marginBottom: "10px" }}>
                <div className={["blueText", "subtitleSize"].join(" ")}>Observação</div>
                {(DROPDOWN_COMPANY_KEYS.includes(company_key) || DROPDOWN_BUSINESS_GROUP_KEYS.includes(business_group_key)) && allowChanges && !disableChange ? (
                    <div style={{ marginBottom: "8px" }}>
                        <div className={["blueText", "normalMediumSize"].join(" ")}>Motivo de análise</div>
                        <Select
                            style={reason === 'select' ? { paddingLeft: "8px", minWidth: "100%", color: "#777" } : { paddingLeft: "8px", minWidth: "100%" }}
                            labelId="reason-selection"
                            id="reason-selection-dropdown"
                            value={reason}
                            label="Razão"
                            onChange={(e) => updateReason(e.target.value)}
                        >
                            <MenuItem value="select" style={{ color: "#777" }}>Selecionar</MenuItem>
                            <MenuItem value="application_fraud">Application Fraud</MenuItem>
                            <MenuItem value="mule_account">Mule Account</MenuItem>
                            <MenuItem value="scammer_account">Scammer Account</MenuItem>
                            <MenuItem value="other">Other</MenuItem>
                        </Select>
                    </div>
                ) : null}
                <ThemeProvider theme={theme}>
                    <TextField
                        fullWidth
                        multiline
                        color="primary"
                        variant="outlined"
                        margin="dense"
                        rows="5"
                        disabled={!(allowChanges && !disableChange)}
                        onChange={handleObservationBoxChange}
                        value={observationBox !== null ? observationBox : (allowChanges ? (disableChange ? 
                            "Aprovado automaticamente devido ao esgotamento do tempo" : "") : 
                            observation == null ? (analyst || "") : (analyst + observation))}
                    />
                </ThemeProvider>
            </div>
            {(allowChanges && !disableChange) ? 
            <div>
                <div style={{ display: "flex", marginTop: "10px" }}>
                    <div 
                        className={["button", "approved", "normalText", "normalMediumSize"].join(" ")} 
                        style={{ color: "#141414", marginLeft: "auto" }}
                        onClick={handleApprovedOpenClick}
                    >
                        APROVAR 
                    </div>     
                    <div 
                        className={["button", "reproved", "normalText", "normalMediumSize"].join(" ")} 
                        style={{ color: "#141414", marginRight: "10px" }}
                        onClick={handleReprovedOpenClick}
                    >
                        REPROVAR 
                    </div>     
                </div>
                <ConfirmationDialog
                    open={openDialog}
                    isApproved={isApproved}
                    observation={observationBox}
                    onClose={handleDialogClose}
                    transaction={props.transaction}
                />
            </div> : null
            }
        </div>
    )        
}

export default Observation;